/**
 * Checklist support is intentionally soft-disabled in the Check-ins UI.
 *
 * Keep the legacy data and request contracts intact so existing cycles can be
 * edited without silently deleting their stored `priorities` configuration.
 */
export const CHECKLISTS_ENABLED = false;

export const isVisibleCheckinParam = (param: string) =>
  CHECKLISTS_ENABLED || param !== 'priorities';

export const getVisibleCheckinParams = (params?: string[]) =>
  (params || []).filter(isVisibleCheckinParam);

export const isVisibleContentBlock = <T extends {type: string}>(block: T) =>
  CHECKLISTS_ENABLED || block.type !== 'checklist';

export const getVisibleContentBlocks = <T extends {type: string}>(blocks: T[]) =>
  blocks.filter(isVisibleContentBlock);
